/**
 * The class to hold the descriptive values for Assessment data
 */
export class UserInfoEnums {
  static BusinessTypeValues: {[key: number]: string} = {};
  static CustomersPerMonth: {[key: number]: string} = {};


  static initialize() {
    // Business Types
    UserInfoEnums.BusinessTypeValues[1] = $localize`:@@BusinessTypeDietitian:Dietitian`;
    UserInfoEnums.BusinessTypeValues[2] = $localize`:@@BusinessTypeGymOwner:Gym Owner`;
    UserInfoEnums.BusinessTypeValues[3] = $localize`:@@BusinessTypeCoach:Coach`;
    UserInfoEnums.BusinessTypeValues[4] = $localize`:@@BusinessTypeDoctor:Doctor`;
    UserInfoEnums.BusinessTypeValues[5] = $localize`:@@BusinessTypeOther:Other`;

     // Customers Per Month
     UserInfoEnums.CustomersPerMonth[1] = '1-5';
     UserInfoEnums.CustomersPerMonth[2] = '6-10';
     UserInfoEnums.CustomersPerMonth[3] = '11-20';
     UserInfoEnums.CustomersPerMonth[4] = '21-50';
     UserInfoEnums.CustomersPerMonth[5] = '50+';

  }

}

UserInfoEnums.initialize();
